import styled from 'styled-components';

const NonSticky = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export default NonSticky;
